import { Button, Drawer, Hairline, Message } from "@components";
import React from "react";
import Toggle2 from "shared/components/Toggle2";
import styles from "../../../../styles/integrations.module.scss";
import { EnvironmentStorage } from "shared/tools/EnvironmentStorage";
import { EnvironmentsAPI } from "providers/EnvironmentsAPI";



export default class ConfirmAddressDrawer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      validateAddress: false,
    };
  }

  async componentDidMount() {
    const environment = await EnvironmentStorage.getEnvironment();
    const addressVerify = await EnvironmentsAPI.getConfigurationsByAlias(
      environment?.id,
      "confirm_address",
      []
    );
    this.setState({
      validateAddress: addressVerify?.active,
    });
  }

  async onToggleValidation(type) {
    const { validations } = this.state;
    if (validations.includes(type)) {
      this.setState({
        validations: validations.filter((validation) => validation !== type),
      });
    } else {
      this.setState({
        validations: [...validations, type],
      });
    }
  }

  async save () {
    this.setState({ loading: true });
    
    const environment = await EnvironmentStorage.getEnvironment();
    const validationResponse = await EnvironmentsAPI.putConfigurationsByAlias(
      environment.id,
      "confirm_address",
      {
        confirm_address: { active: this.state.validateAddress},
      }
    );

    if (validationResponse.getErrors([]).length > 0) {
      alert({
        text: validationResponse.getErrors()[0],
        buttonText: "Ok",
      });
      this.setState({ loading: false });
      return false;
    }

    alert({
      text: "Configuração alterada com sucesso!",
      buttonText: "Ok",
    });

    this.setState({ loading: false });
    return true;
  }

  render() {
    const { visible, onClose } = this.props;
    const { loading } = this.state;

    return (
      <Drawer
        visible={visible}
        onClose={onClose}
        closeInFade
        title="Confirmações de endereço"
      >
        
        <Toggle2
          id="confirm-address"
          title="Ativar confirmação de endereço"
          checked={this.state.validateAddress}
          onChange={() => this.setState({ validateAddress: !this.state.validateAddress })}
        />
        <Hairline className="mt-10 mb-10" />
        

        <div className={styles.footer}>
          <Button
            className="w-100"
            design="primary"
            disabled={loading}
            loading={loading}
            onClick={() => this.save()}
          >
            Salvar
          </Button>
        </div>
      </Drawer>
    );
  }
}
